import {Heading, Img} from "./..";
import React from "react";

interface Props {
    icon?: string;
    title?: string;
    description?: string;
    bg?: string;
    text?: string;
}

export default function WhyUsTabs({...props}) {
    return (
        <div
            {...props}
            className={`${props.className} ${props.bg} ${props.text} flex flex-col w-full lg:gap-[100px] lg:rounded-[48px] gap-12 rounded-[32px]`}
            >
            <Img
                src={props.icon}
                alt="icon"
                className="lg:h-[120px] lg:w-[120px] w-[68px] h-[68px] object-contain mt-10 ml-10 md:mt-6 md:ml-6 sm:mt-6 sm:ml-6"/>
            <div className="mb-[82px] flex items-start self-stretch px-10 md:px-6 md:mb-6 sm:flex-col sm:mb-6 sm:px-6">
                <Heading
                    size="desktop_heading_4"
                    className="md:hidden sm:hidden font-semibold leading-[120%] uppercase w-[305px] h-[112px] whitespace-pre-line">
                    {props.title}
                </Heading>
                <Heading
                    size="desktop_body_l"
                    className="md:hidden sm:hidden font-medium whitespace-pre-line">
                    {props.description}
                    </Heading>
                {/*--------------*/}
                <Heading
                    className="lg:hidden sm:hidden font-medium text-[20px] leading-[120%] uppercase w-[305px] whitespace-pre-line">
                    {props.title}
                </Heading>
                <Heading
                    size={"desktop_body_m"}
                    className="lg:hidden sm:hidden font-medium w-[50%]">
                    {props.description}
                </Heading>
                {/*--------------*/}
                <Heading
                    size="desktop_heading_6"
                    className="lg:hidden md:hidden font-medium leading-[120%] uppercase w-[305px] h-auto ">
                    {props.title}
                </Heading>
                <Heading
                    size="desktop_body_m"
                    className="lg:hidden md:hidden font-medium whitespace-pre-line mt-4">
                    {props.description}
                </Heading>
            </div>
        </div>
    )
}